import { createContext, useContext } from 'react';
import type { MooChatConfig } from '../types';
import type { ShellState } from '../state/shell-state';
import type { ShellAction } from '../state/shell-actions';

export interface MooChatContextValue {
  config: MooChatConfig;
  state: ShellState;
  dispatch: (action: ShellAction) => void;
}

export const MooChatContext = createContext<MooChatContextValue | null>(null);

export function useMooChatContext(): MooChatContextValue {
  const value = useContext(MooChatContext);
  if (value === null) {
    throw new Error(
      'useMooChat* hook called outside a <MooChatProvider>. ' +
        'Render <MooChatProvider config={...}> above this component.',
    );
  }
  return value;
}

/** Convenience hook for code that only needs config (e.g., adapters). */
export function useMooConfig(): MooChatConfig {
  return useMooChatContext().config;
}
